var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation-menu'),_vm._v(" "),_c('add-new-contact-modal',{ref:"addNewContactModal"}),_vm._v(" "),_c('add-new-group-modal',{ref:"addNewGroupModal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }